import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

export function getCurrentUser(): JQueryPromise<modelsGet.IUser>
{
    return api.get<modelsGet.IUser>({
        endpoint: "api/accounts/current-user"
    });
}

export function getCurrentUsersNotificationsCount(): JQueryPromise<number>
{
    return api.get<number>({
        endpoint: "api/accounts/current-user/notifications/count"
    });
}

export function getCurrentUsersNotifications(): JQueryPromise<modelsGet.IUserNotification[]>
{
    return api.get<modelsGet.IUserNotification[]>({
        endpoint: "api/accounts/current-user/notifications"
    });
}

export function getCurrentUsersSubscriptions(): JQueryPromise<modelsGet.ISubscription[]> {
    return api.get<modelsGet.ISubscription[]>({
        endpoint: "api/accounts/current-user/notifications/subscriptions"
    });
}

export function getAllEverSignedInUsers(): JQueryPromise<modelsGet.IUser[]>
{
    return api.get<modelsGet.IUser[]>({
        endpoint: "api/accounts/accs"
    });
}

export function signin(jsonData: any, endpoint: string = "/accounts/signin?returnurl=%2F"): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: endpoint,
        data: JSON.stringify(jsonData)
    });
}

export function signout(): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "/accounts/signout"
    });
}

export function changeUser(user: modelsPost.IUserProfile): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/accounts",
        data: JSON.stringify(user)
    });
}


export function changePassword(password: modelsPost.IUserProfilePassword): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/accounts/password",
        data: JSON.stringify(password)
    });
}

///**
// * AUFGEPASST: Der Parementername, in dem Fall "file", muss identisch mit dem Parameternamen
// * des API-Enpunkts auf dem Server sein.
// * @param file 
// */
//export function changePicture(file: FormData): JQueryPromise<any>
//{
//    return api.put({
//        contentType: false,
//        endpoint: "api/accounts/picture",
//        data: file,
//        processData: false
//    });
//}

export function changePicture(dataUrl: string): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/accounts/picture",
        data: JSON.stringify({
            picture: dataUrl
        })
    });
}

export function markNotificationAsRead(id: number): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/accounts/notifications/${id}/mark_as_read`
    });
}

export function deleteReadNotifications(): JQueryPromise<any>
{
    return api.remove({
        contentType: "application/json",
        endpoint: "api/accounts/notifications/delete_read"
    });
}

export function deleteAllNotifications(): JQueryPromise<any>
{
    return api.remove({
        contentType: "application/json",
        endpoint: `api/accounts/notifications`
    });
}

export function deleteNotification(id: number): JQueryPromise<any>
{
    return api.remove({
        contentType: "application/json",
        endpoint: `api/accounts/notifications/${id}`
    });
}